var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.7 86.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3,0C19.4,0,0,19.4,0,43.3c0,23.9,19.4,43.3,43.3,43.3c23.9,0,43.3-19.4,43.3-43.3C86.7,19.4,67.3,0,43.3,0z M70.2,43.3 c0,3.5-2.8,6.4-6.4,6.4H22.8c-3.5,0-6.4-2.8-6.4-6.4v0c0-3.5,2.8-6.4,6.4-6.4h41.1C67.4,37,70.2,39.8,70.2,43.3L70.2,43.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.e669b9780def879bddd3fdd3bdaf6a21.svg";
export { ForwardRef as ReactComponent };